var AddressFormatter = Object.create(null);

AddressFormatter.formatAddress = formatAddress;

/**
 * Permet de formatter une adresse
 * @param {string} address - Adresse
 * @param {string} postcode - Code postal
 * @param {string} city - Ville
 * @param {string} complementaryAddress - Complément d'adresse
 * @returns {string}
 */
function formatAddress(address, postcode, city, complementaryAddress) {
  var cpAddressPart = [],
    array = [];

  if (address) {
    array.push(address);
  }

  if (postcode) {
    cpAddressPart.push(postcode);
  }

  if (city) {
    cpAddressPart.push(city);
  }

  if (cpAddressPart.length) {
    array.push(cpAddressPart.join(' '));
  }

  if (complementaryAddress) {
    array.push(complementaryAddress);
  }

  return array.join(', ');
}

module.exports = AddressFormatter;
